import { GET_ALL_SETTING_DAYS } from '../constants/setting_days';

export const judgeDayMixin = {
    data () {
        return {
            settingDayTbl: []
        };
    },
    created () {
        this.getSettingDays();
    },
    methods: {
        /** ----------------------------------------------
         * 曜日判定
         * 曜日を判定する
         * 引数がnullの場合は現在日の曜日を判定する
         * @param  {Date} date 日付
         * @return {Boolean} 平日:1～5 土:6 日祝:0
         * ---------------------------------------------- */
        judgeDay: function (date) {
            var targetDate;
            if (date === null) {
                targetDate = new Date();
            } else {
                targetDate = date;
            }

            var dayNum = targetDate.getDay();
            var judge = dayNum;
            // 日曜又は土曜の場合
            if (dayNum === 0 || dayNum === 6) {
                return dayNum;
            }

            var targetDateStr =
                    ('0' + (targetDate.getMonth() + 1)).slice(-2) +
                    ('0' + (targetDate.getDate())).slice(-2);
            var targetDateWeek =
                    ('0' + (targetDate.getMonth() + 1)).slice(-2) +
                    ('0' + (Math.floor((targetDate.getDate() + 6) / 7))).slice(-2) +
                    ('0' + (targetDate.getDay())).slice(-2);

            for (var i = 0; i < this.settingDayTbl.length; i++) {
                // 曜日指定タイプが日付固定の場合
                if (this.settingDayTbl[i].date_type === 1) {
                    if (this.settingDayTbl[i].month_day === targetDateStr) {
                        judge = 0;
                        break;
                    }
                // 曜日指定タイプが対象日指定の場合
                } else {
                    if (this.settingDayTbl[i].month_day === targetDateWeek) {
                        judge = 0;
                        break;
                    }
                }
            }

            return judge;
        },
        /** ----------------------------------------------
         * 祝日テーブル取得
         * 祝日テーブルを取得する
         * ---------------------------------------------- */
        async getSettingDays () {
            this.settingDayTbl = [];
            // 祝日テーブル検索
            await this.$apollo.query({
                query: GET_ALL_SETTING_DAYS,
                variables: {
                    golf_group_code: process.env.VUE_APP_GROUP_CODE
                }
            }).then(res => {
                this.settingDayTbl = res.data.GetAllSettingDays.AllSettingDays;
            });
        }
    }
};
